import axiosInstance from "../../utils/axiosCompany";

export const GetPaymentMethods = async (values) => {
    return await axiosInstance().post("company/order/get-payment-methods", values);
}

export const CreateOrders = async (values) => {
    return await axiosInstance().post("company/order/create-order", values);
}
export const GetOrdersList = async (values) => {
    return await axiosInstance().post("company/order/list-order-company-panel", values);
}
export const ExportOrdersList = async (values) => {
    return await axiosInstance().post("company/order/list-order", values);
}
export const GetSingleOrderDetails = async (values) => {
    return await axiosInstance().post("company/order/get-single-order", values);
}
export const GetRecallOrderDetails = async (values) => {
    return await axiosInstance().post("company/order/get-recall-order-details", values);
}
export const RefundStatus = async (values) => {
    return await axiosInstance().post("company/order/change-payment-status", values);
}
export const RecallOrder = async (values) => {
    return await axiosInstance().post("company/order/recall-order", values);
}
export const checkoutOrder = async (values) => {
    return await axiosInstance().post("company/order/checkout-order", values);
}
export const CouponValidator = async (values) => {
    return await axiosInstance().post(`company/order/validate-coupon`, values);
};
export const GetMealCombosOrder = async (values) => {
    return await axiosInstance().post("company/order/combos", values);
}
export const GetMenuItemsOrder = async (values) => {
    return await axiosInstance().post("company/order/menu-items", values);
}
export const reportToZatcaAgain = async (values) => {
    return await axiosInstance().post("company/order/report-to-zatca-again", values)
}

// Orders whose ZATCA sale invoice (sync_type "payment") or credit note ("refund")
// failed. Cursor paged: send the previous response's next_id as last_id (0 for the
// first page). global_search is an exact order id and overrides every filter.
export const ListZatcaUnsyncedOrders = async (values) => {
    return await axiosInstance().post("company/order/list-zatca-unsynced-orders", values);
}

export const forceOrderClose = async (values) => {
    return await axiosInstance().post("company/order/force-close-order", values);
}

export const createDummyOrdersForCompany= async (values) => {
    return await axiosInstance().post("company/testing/create-dummy-orders", values);
}

export const GetOrderModes = async (values) => {
    return await axiosInstance().post("company/order/modes", values);
}

export const GetOrderAggregators = async (values) => {
    return await axiosInstance().post("company/order/aggregators", values);
}

export const RefundOrderRequest = async (values) => {
    return await axiosInstance().post("company/order/refund-order-request", values);
}

export const DeletePendingOrder = async (values) => {
    return await axiosInstance().post("company/order/delete-pending-order", values);
}

